import {useCallback} from 'react';
import EditorUserInfoCard from '@/components/EditorUserInfoCard';

export const useEditorUserInfoCard = ({
    showPermissionBtn,
    docUrl,
}: {
    showPermissionBtn: boolean;
    docUrl?: string;
}) => {
    return useCallback((
        element,
        options: {
            from?: string;
            setTooltipVisible?: (visible: boolean) => void;
        } = {}
    ) => {
        const {
            mentionType,
            mentionId,
            mentionName,
            mentionSubtitle,
            mentionDescription,
        } = element;
        return <EditorUserInfoCard
            type={mentionType}
            department={mentionDescription}
            nickname={mentionName}
            email={mentionSubtitle}
            userGuid={mentionId}
            from={options.from}
            showPermissionBtn={showPermissionBtn}
            setTooltipVisible={options.setTooltipVisible}
            docUrl={docUrl}
        />;
    }, [showPermissionBtn, docUrl]);
};
